import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import axios from 'axios'
import { branchService } from '../services/branchService'
import type { BranchFormData } from '../types'

export function useBranchMutation() {
  const navigate = useNavigate()
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const create = async (data: BranchFormData) => {
    setIsSubmitting(true)
    setError(null)
    try {
      await branchService.create(data)
      navigate('/branches')
    } catch (err) {
      if (axios.isAxiosError(err)) {
        const detail = err.response?.data?.detail
        setError(typeof detail === 'string' ? detail : 'Error al crear sucursal')
      } else {
        setError('Error al crear sucursal')
      }
    } finally {
      setIsSubmitting(false)
    }
  }

  const update = async (id: number, data: BranchFormData) => {
    setIsSubmitting(true)
    setError(null)
    try {
      await branchService.update(id, data)
      navigate('/branches')
    } catch (err) {
      if (axios.isAxiosError(err)) {
        const detail = err.response?.data?.detail
        setError(typeof detail === 'string' ? detail : 'Error al actualizar sucursal')
      } else {
        setError('Error al actualizar sucursal')
      }
    } finally {
      setIsSubmitting(false)
    }
  }

  const remove = async (id: number) => {
    setIsSubmitting(true)
    setError(null)
    try {
      await branchService.delete(id)
    } catch (err) {
      if (axios.isAxiosError(err)) {
        const detail = err.response?.data?.detail
        setError(typeof detail === 'string' ? detail : 'Error al eliminar sucursal')
      } else {
        setError('Error al eliminar sucursal')
      }
    } finally {
      setIsSubmitting(false)
    }
  }

  return { create, update, remove, isSubmitting, error }
}
